import model from "@js/model.js";
import { isObject, isUndefined } from "@helpers/utils.js"


export default {
	initImages(){
		EGOE.handleImageError = img => img.style.display = 'none';
		this.addErrorHandlerToImages();
	},
	addErrorHandlerToImages(imgs){
		if (isUndefined(imgs) || imgs.length === 0) imgs = document.querySelectorAll('img');
		imgs.forEach(img => img.setAttribute('onError', 'EGOE.handleImageError(this)'));
	},
	preloadImgAsync(params){
		return new Promise(resolve => {
			if(typeof params.success === 'function'){
				let oldSuccess = params.success;
				params.success = (src, target) => {
					oldSuccess(src, target);
					resolve({src, target});
				}
			}
			else params.success = (src, target) => {
				resolve({src, target});
			};
	
			this.preloadImg(params);
		});
	},
	preloadImg(params){
		if (typeof params.webp !== 'boolean') params.webp = true;

		let element = params.element;

		if(!params.imgUrl || params.imgUrl == 'null' || params.imgUrl == 'undefined'){
			executeErrorState();
			return;
		}

		if(element?.tagName === 'IMG'){
			element.crossOrigin = 'Anonymous';
			if (params.webp) element.src = this.changeExtToWebP(params.imgUrl);
			else element.src = params.imgUrl;

			element.onload = e => {
				params.success && params.success(e.currentTarget.src, e.currentTarget);
			}

			addAlt(element);
			handleOnErr(element);
			return;
		}

		var image = new Image();
		image.crossOrigin = 'Anonymous';
		if (params.webp) image.src = this.changeExtToWebP(params.imgUrl);
		else image.src = params.imgUrl;
		image.onload = e => {
			if (element) {
				element.style.backgroundImage = `url(${e.currentTarget.src})`;
				element.setAttribute('onError', 'EGOE.handleImageError(this)');
			}

			params.success && params.success(e.currentTarget.src, e.currentTarget);
		};

		addAlt(image);
		handleOnErr(image);

		function handleOnErr(image){
			image.onerror = e => {
				executeErrorState(image, e);
			};
		}

		function executeErrorState(image, e){
			if (typeof params.error === 'function') params.error(e || {});
			else {
				if(image) EGOE.handleImageError(image);
				params.success && params.success();
			}
		}

		function addAlt(image){
			if(params.imgUrl && typeof params.imgUrl === 'string'){
				image.alt = params.imgUrl.substring(params.imgUrl.lastIndexOf('/') + 1, params.imgUrl.lastIndexOf('.'));
			}
		}
	},
	changeExtToWebP: (function(){
		var formatExceptions = ['svg'];
		return function(src){
			if(isObject(src)){
				let key = Object.keys(src).find(key => model.webpSupported ? key.includes('.webp') : !key.includes('.webp'));
				src = src[key];
			}

			if(!src) return null;
			if(model.webpSupported && !formatExceptions.includes(src.substr(src.lastIndexOf('.') + 1).toLowerCase())) return src.replace(/\.(jpg|png)/gi, '.webp');
			return src;
		};
	}()),
}